'use client'

import * as React from 'react'
import { ClipboardCopyIcon, Link2Icon } from '@radix-ui/react-icons'
import { slugify } from '@basehub/utils/case/index'
import { clsx } from 'clsx'
import { toast } from 'sonner'

import { ButtonLink } from '~/sotano-kit/primitives/button'

type AnchorHeadingProps = React.JSX.IntrinsicElements['h1'] & {
  as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  href?: string
}

export const AnchorHeading = React.forwardRef<
  HTMLHeadingElement,
  AnchorHeadingProps
>(({ children, as, className, id, href, ...rest }, ref) => {
  const Element: React.ElementType = as

  return (
    <Element
      {...rest}
      ref={ref}
      id={slugify(id ?? '')}
      className={clsx(
        className,
        'relative scroll-mt-[calc(var(--header-height)+theme(spacing.6))]'
      )}
    >
      {!id ? (
        children
      ) : (
        <ButtonLink
          href={href ?? `#${slugify(id)}`}
          unstyled
          focusStyled
          className="group"
          onClick={() => {
            if (href || !id) return

            navigator.clipboard.writeText(
              window.location.origin + window.location.pathname + `#${id}`
            )
            toast.success('Section link copied to clipboard', {
              icon: <ClipboardCopyIcon width={16} height={16} />,
            })
          }}
        >
          {children}
          {!href && (
            <Link2Icon
              width={15}
              height={15}
              className="inline-block text-dark-muted relative align-middle ml-2 group-focus-visible:opacity-100 group-focus:opacity-100 group-hover:opacity-100 transition-all opacity-0 duration-200 mb-1 translate-y-1 group-hover:translate-y-0 group-focus-visible:translate-y-0 group-focus:translate-y-0"
            />
          )}
        </ButtonLink>
      )}
    </Element>
  )
})
